import { Button } from '@mantine/core';
import { FiLink } from 'react-icons/fi';
import { isMobile } from 'react-device-detect';

interface ShareJobButtonProps {
  onShareJob: () => void;
}

export default function ShareJobButton({ onShareJob }: ShareJobButtonProps) {
  return (
    <Button
      onClick={onShareJob}
      leftSection={<FiLink size={20} />}
      px={10}
      ff="PT Sans, sans-serif"
      fz={14}
      fullWidth={isMobile}
    >
      Share Job
    </Button>
  );
}
